import { lazy, useContext, useMemo } from "react";
// constants
import { TIMESACT_VERSION_2 } from "./common/constants";
// contexts
import { VersionStoreContext } from "./contexts/VersionStoreContext";

// V1 Routes (Firebase)
const V1Routes = lazy(() => import("./routesV1"));

// V2 Routes (DB)
const V2Routes = lazy(() => import("./routesV2"));

const AppRoutes = () => {
  const { timesactVersion, isVersionLoaded } = useContext(VersionStoreContext);
  const memoizedV1 = useMemo(() => <V1Routes />, []);
  const memoizedV2 = useMemo(() => <V2Routes />, []);

  if (!isVersionLoaded) {
    return;
  }

  if (timesactVersion && timesactVersion === TIMESACT_VERSION_2) {
    return memoizedV2;
  } else {
    return memoizedV1;
  }
};

export default AppRoutes;
